import React from "react";
import { SVGProps } from "react";
function Icon(
  props: SVGProps<SVGSVGElement> & {
    active?: boolean;
  }
) {
  const fill = props.active ? "var(--task-link-color)" : "#9CA6A9";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        fill={fill}
        d="M11.615 2.795c0-.857-.719-1.557-1.605-1.557-.885 0-1.606.698-1.606 1.557 0 .088.008.174.022.258-2.217.748-4.037 3.049-4.037 5.77v2.14s0 3.084-.782 3.111c-.466 0-.824.348-.824.778 0 .431.36.777.803.777h12.848a.789.789 0 00.802-.777.788.788 0 00-.802-.778c-.803 0-.803-3.09-.803-3.09V8.82c0-2.722-1.701-5.023-4.037-5.771.013-.082.021-.168.021-.254zm.803 13.61c-.002 1.29-1.07 2.333-2.408 2.333-1.328 0-2.406-1.04-2.408-2.334"
      ></path>
    </svg>
  );
}

export default Icon;
